import { api } from '@/modules/shared/lib/axios'
import type { ResponseAPI } from '@/modules/shared/types/response-api.type'

export interface IGetOperationsOrderService {
  companyId: string
}

export const getOperationsOrderService = async ({
  companyId,
}: IGetOperationsOrderService) => {
  const { data } = await api.get<ResponseAPI>(`tabelascadastro/${companyId}`)

  return data
}
